const PRIMEIRO_ANO_INFORME = 2025;

export function getAnosDisponiveisInformeRendimento(referencia: Date = new Date()): number[] {
  const anoAtual = referencia.getFullYear();
  const ultimoAnoComInforme = anoAtual - 1;
  if (ultimoAnoComInforme < PRIMEIRO_ANO_INFORME) {
    return [];
  }
  const anos: number[] = [];
  for (let ano = PRIMEIRO_ANO_INFORME; ano <= ultimoAnoComInforme; ano++) {
    anos.push(ano);
  }
  return anos;
}

export function getAnoPadraoInforme(anos: number[]): number | null {
  if (anos.length == 0) {
    return null;
  }
  return Math.max(...anos);
}
